
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"applicationFormHealthFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"applicationFormHealth"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"form_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nursed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nursed_age"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"diet"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dietary_supplements_vitamins"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"food_allergy_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"food_allergy_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allergies"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allergies_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"food_cravings"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"picky_eater"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"overeats"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"poor_appetite"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"colds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ear_infections"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ear_infection_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ear_infections_times"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ear_infections_period_of_time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tinnitus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tinnitus_ear_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tinnitus_continuous"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hearing_loss"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hearing_loss_ear_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hearing_loss_degree"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hypersensitive_hearing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tympanogram"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tympanogram_results"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eye_examination"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"glasses_lenses"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"glasses_lenses_prescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vision_therapy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vision_therapy_comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sleep_time_from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sleep_time_to"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"naps_time_from"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"naps_time_to"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seeing_specialist"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"specialist_other_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"specialist_counselor_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"other_health_problems"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"other_health_problems_list"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":856}};
    doc.loc.source = {"body":"fragment applicationFormHealthFields on applicationFormHealth {\n  form_id\n  nursed\n  nursed_age\n  diet\n  dietary_supplements_vitamins\n  food_allergy_id\n  food_allergy_description\n  allergies\n  allergies_description\n  food_cravings\n  picky_eater\n  overeats\n  poor_appetite\n  colds\n  ear_infections\n  ear_infection_id\n  ear_infections_times\n  ear_infections_period_of_time\n  tinnitus\n  tinnitus_ear_id\n  tinnitus_continuous\n  hearing_loss\n  hearing_loss_ear_id\n  hearing_loss_degree\n  hypersensitive_hearing\n  tympanogram\n  tympanogram_results\n  eye_examination\n  glasses_lenses\n  glasses_lenses_prescription\n  vision_therapy\n  vision_therapy_comment\n  sleep_time_from\n  sleep_time_to\n  naps_time_from\n  naps_time_to\n  seeing_specialist\n  specialist_other_description\n  specialist_counselor_description\n  other_health_problems\n  other_health_problems_list\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["applicationFormHealthFields"] = oneQuery(doc, "applicationFormHealthFields");
        
